export const SELECT_OPINION_PHRASES = {
    FREQUENTLY_ASKED_QUESTIONS: 19750,
    HOW_DOES_IT_WORK: 22184,
    ABOUT_SELECT_OPINION: 21951,
    ABOUT_SELECT_OPINION_DETAILS: 21952,
    YOU_ARE_INVITED_TO_JOIN: 21928,
    JOIN_SELECT_OPINION_HERE: 21929,
    SELECT_OPINION_PAGE_TITLE: 21981,
    SELECT_OPINION_REGISTER_PAGE_TITLE: 21982,
    SELECT_OPINION_IS: 21930,
    HOURLY_RATE: 21931,
    CONSULT: 21932,
    IDEA: 21933,
    REGISTER_USING_BUTTON: 21953,
    ACCEPT_OR_DECLINE: 21954,
    RECEIVE_PAYMENTS_THROUGH: 21955,
    EXPERT_NETWORK: 21958,
    NETWORK_OF_EXPERTS_IN_HEALTHCARE: 22050,
    HAPPY_YOU_DECIDED_TO_JOIN: 21979,
    YOURE_ONE_STEP_CLOSER: 21980,
    ADDITIONAL_EMPLOYMENT: 21984,
    ADD_ANOTHER_EMPLOYMENT: 21983,
    SUCCESSFULL_REGISTRATION_MESSAGE: 22080,
    REMOVE: 1722,
    TITLE: 21988,
    COMPANY: 21985,
    START_DATE: 21986,
    END_DATE: 21987,
    MINIMUM_OF_TWO_YEARS_EMPLOYMENT_HISTORY: 22051,
    CHOOSE_FILE: 2804,
    UPLOAD_CV: 21999,
    SELECT_FILE: 22000,
    UPLOAD_CV_TOOLTIP: 22001,
    ADDITIONAL_EMPLOYMENT_TOOLTIP: 22002,
    MOST_RECENT_EMPLOYMENT: 22016,
    MOST_RECENT_EMPLOYMENT_TOOLTIP: 22015,
    PRESENT_EMPLOYER: 22014,
    LINKEDIN_URL: 22010,
    LINKEDIN_URL_TOOLTIP: 22012,
    LINKEDIN_URL_PLACEHOLDER: 22011,
    DECLARATIONS_BEFORE_SIGN_UP: 22005,
    DECLARATIONS_CODE_OF_CONDUCT: 22006,
    DECLARATIONS_TERMS_AND_CONDITIONS: 22007,
    DECLARATIONS_THIRD_PARTY_AGREEMENT: 22008,
    ENTER_YOUR_DESIRED_HOURLY_RATE: 22003,
    ENTER_YOUR_DESIRED_HOURLY_RATE_TOOLTIP: 22013,
    HOURLY_RATE_INPUT: 22004,
    REGISTER: 22018,
    SELECT_OPINION_CONSULTING_OPPORTUNITIES_PAGE_TITLE: 22046,
    WELCOME_TO_SELECT_OPINION: 22038,
    IF_YOU_HAVE_ACCESS: 22039,
    PLEASE_LOG_IN: 22040,
    SIGN_IN_URL: 22072,
    DEV_SIGN_IN_URL: 22071,
    SIGN_IN_TO_SELECT_OPINION: 22041,
    FAQ_INFO_BOX_TITLE: 22042,
    PDF_INFO_BOX_TITLE: 22044,
    SUPPORT_INFO_BOX_TITLE: 22043,
    IF_YOU_NO_LONGER: 22045,
    UNSUBSCRIBE: 22183,
    YOUR_REQUEST_IS_NO_LONGER: 22049,
    CLOSE: 3467,
    CODE_OF_CONDUCT_TITLE: 22056,
    CODE_OF_CONDUCT_CONTENT: 22057,
    PRIVACY_POLICY_TITLE: 22058,
    PRIVACY_POLICY_CONTENT: 22059,
    MASTER_USER_AGREEMENT_TITLE: 22060,
    MASTER_USER_AGREEMENT_CONTENT: 22061,
    HOURLY_RATE_DESCRIPTION: 22081,
    CANCEL: 22185,
    PLEASE_UPLOAD_YOUR_CV: 22186,
    NOT_INVITED_USER_TRIES_TO_ACCESS: 22180,
    OPTED_OUT_USER_TRIES_TO_ACCESS: 22181,
    KNOWLEDGE_SUMMARY: 22299,
    PROVIDE_SHORT_DESCRIPTION: 22300,
    KNOWLEDGE_SUMMARY_TEXTAREA_PLACEHOLDER: 22303,
} as const;
